import { render, staticRenderFns } from "./BottomNavBar.vue?vue&type=template&id=c5ebb880&scoped=true"
import script from "./BottomNavBar.vue?vue&type=script&lang=js"
export * from "./BottomNavBar.vue?vue&type=script&lang=js"
import style0 from "./BottomNavBar.vue?vue&type=style&index=0&id=c5ebb880&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ebb880",
  null
  
)

export default component.exports